export default __webpack_public_path__ + "static/media/pin-the-lane-square-in-tai-po.019f04bf.png";